// Retired Traveler - Travel Guide detail page image fix v2
(function () {
  function isGuidePage() {
    var text = document.body && document.body.innerText ? document.body.innerText : '';
    return text.indexOf('Back to All Destinations') !== -1 || text.indexOf('All Destinations') !== -1;
  }

  function markLikelyHeroImages() {
    if (!isGuidePage()) return;
    document.body.classList.add('rt-travel-guide-detail');

    var main = document.querySelector('main') || document.body;
    var imgs = Array.prototype.slice.call(main.querySelectorAll('img'));

    imgs.forEach(function (img) {
      var rect = img.getBoundingClientRect();
      var naturalWide = img.naturalWidth >= 500 || rect.width >= 240;
      var belowTitleArea = rect.top > 250 || img.closest('section, .shopify-section, .page-width');

      if (naturalWide && belowTitleArea) {
        var wrapper = img.closest('picture, .media, .card__media, .image-with-text__media, .banner__media, .section, section, .shopify-section, .page-width') || img.parentElement;
        if (wrapper) wrapper.classList.add('rt-guide-fixed-image');
        img.classList.add('rt-guide-fixed-target');

        img.style.setProperty('display', 'block', 'important');
        img.style.setProperty('position', 'static', 'important');
        img.style.setProperty('inset', 'auto', 'important');
        img.style.setProperty('transform', 'none', 'important');
        img.style.setProperty('width', '100%', 'important');
        img.style.setProperty('max-width', '100%', 'important');
        img.style.setProperty('height', 'auto', 'important');
        img.style.setProperty('max-height', 'none', 'important');
        img.style.setProperty('object-fit', 'contain', 'important');
        img.style.setProperty('object-position', 'center center', 'important');
        img.style.setProperty('aspect-ratio', 'auto', 'important');
        img.style.setProperty('border-radius', '18px', 'important');

        var node = img.parentElement;
        for (var i = 0; node && i < 4; i++) {
          node.classList.add('rt-guide-fixed-image');
          node.style.setProperty('height', 'auto', 'important');
          node.style.setProperty('min-height', '0', 'important');
          node.style.setProperty('max-height', 'none', 'important');
          node.style.setProperty('padding', '0', 'important');
          node.style.setProperty('overflow', 'hidden', 'important');
          node.style.setProperty('aspect-ratio', 'auto', 'important');
          node = node.parentElement;
        }
      }
    });

    var bgNodes = Array.prototype.slice.call(main.querySelectorAll('[style*="background-image"]'));
    bgNodes.forEach(function (el) {
      el.classList.add('rt-guide-fixed-bg');
      el.style.setProperty('background-size', 'contain', 'important');
      el.style.setProperty('background-repeat', 'no-repeat', 'important');
      el.style.setProperty('background-position', 'center center', 'important');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markLikelyHeroImages);
  } else {
    markLikelyHeroImages();
  }

  window.addEventListener('load', markLikelyHeroImages);
  window.addEventListener('resize', markLikelyHeroImages);
  setTimeout(markLikelyHeroImages, 500);
  setTimeout(markLikelyHeroImages, 1500);
})();
